export const ACTIVE_TABS = {
    WELCOME: "welcome",
    CONVERSATION: "conversation",
    FAQ: "faq"
};

export const CONVERSATION_USER_TYPES = {
    USER: "user",
    BOT: "bot"
}

export const DEFAULT_BOT_IMAGE_URL =
    "https://static-media.gritworks.ai/fe-images/GIF/Shikshalokam/bot_profile_image.gif";

export const DEFAULT_USER_IMAGE_URL = "https://static-media.gritworks.ai/fe-images/PNG/Shikshalokam/defaultImage.png";